// extracted by mini-css-extract-plugin
module.exports = {"listLink":"DetailPage_listLink__GYS8D","breadcrumbItem":"DetailPage_breadcrumbItem__22_Ez"};